<template>
    <div>
        <ModalHeader icon="X" :title="isLoaded ? '계좌번호 ' + (isFirst ? '등록' : '수정') : ''"></ModalHeader>
        <div style="flex:1; padding:20px 15px;">
            <FormInput class="label_wrap" label="은행" placeholder-str="은행명을 입력해주세요" v-model="bankName"></FormInput>
            <FormInput class="label_wrap" label="계좌번호" placeholder-str="계좌번호를 입력해주세요." v-model="bankAccount"></FormInput>
            <FormInput class="label_wrap" label="예금주 이름" placeholder-str="예금주 이름을 입력해주세요." v-model="bankAccountName"></FormInput>
        </div>
        <div style="height:50px; display:grid; place-items: center;  color:white; font-weight:bold;" @click="regist" :style="{backgroundColor : isFull ? '#ff6100' : '#dfdfdf'}">{{isLoaded ? (isFirst ? '등록하기' : '수정하기') : ''}}</div>
    </div>
</template>

<script>
    import ModalHeader from "../../common/ModalHeader";
    import FormInput from "../../common/FormInput";
    export default {
        name: "BankAccountForm",
        components: {FormInput, ModalHeader},
        data(){
            return {
                bankName : '',
                bankAccount : '',
                bankAccountName : '',
                isFirst : true,
                isLoaded : false,
            }
        },
        computed : {
            isFull(){
                return this.bankName && this.bankAccount && this.bankAccountName ;
            }
        },
        methods : {
            async getBankAccount(){
                const res = await this.$Axios.get('/api/bank/account');
                const data = res.data;
                this.isLoaded = true;
                if(data.code === 0){
                    this.bankName = data.bankName;
                    this.bankAccount = data.bankAccount;
                    this.bankAccountName = data.bankAccountName;
                    if(data.bankName || data.bankAccount || data.bankAccountName) this.isFirst = false;
                }
            },
            async regist(){
                if(!this.isFull){
                    if(this.bankName === ''){
                        this.$GlobalStore.showAlert('은행명을 입력해주세요.');
                        return;
                    }
                    if(this.bankAccount === ''){
                        this.$GlobalStore.showAlert('계좌번호를 입력해주세요.');
                        return;
                    }
                    if(this.bankAccountName === ''){
                        this.$GlobalStore.showAlert('예금주 이름을 입력해주세요.');
                        return;
                    }
                }

                const parameters = {};
                parameters.bankName = this.bankName;
                parameters.bankAccount = this.bankAccount;
                parameters.bankAccountName = this.bankAccountName;

                const res = await this.$Axios.post('/api/bank/save', parameters);
                if(res.data.code === 0){
                    this.$GlobalStore.showToast('계좌번호가 ' + (this.isFirst ? '등록' : '수정') + '되었습니다.');
                    this.$GlobalStore.closeLastModal();
                }else {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }

        },
        created(){
            this.getBankAccount();
        }
    }
</script>

<style scoped>
.label_wrap + .label_wrap{margin-top:20px;}
</style>